import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const ClientGoals = React.lazy(
    () => import(/* webpackChunkName: "client-goals" */ '../../../../containers/Client/Goals')
);

export const ClientGoalsRoutes: RouteObject = {
    path: 'goals',
    element: (
        <React.Suspense fallback={<>...</>}>
            <ClientGoals />
        </React.Suspense>
    )
};
